import React from 'react';

export default ({ children, className }) => (
    <h1 className={className} css={{ margin: '0 0 16px 0', textAlign: 'center', paddingBottom: 16, borderBottom: '1px solid #eee' }}>{children}</h1>
);
